<template>
  <div class="flex flex-row items-center justify-center mx-4 menu-container items" @mouseover="mouseEvent($event, 'wrapper')">
<!--    <div @mouseover="mouseEvent($event, 'wrapper')">-->
<!--      <div class="items">-->
        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1 item" :href="route('shop.landing')"
                      @mouseover="mouseEvent($event, 'item', 'categories')"
                      :data="{ anchor: 'categories' }">
          <div class="transition ease-in-out duration-150" style="color:#3c3c3c; font-size: 1rem !important;">
            {{ $t('menu.categories')}}
          </div>
        </inertia-link>

        <!--    <dropdown-menu :overlay="false">-->
        <!--      <button class="a10-nav-link mr-6" slot="trigger" style="text-transform: uppercase !important; color:#3c3c3c; font-size: 1rem !important;">{{ $t('menu.categories') }}</button>-->
        <!--      <div slot="header">-->
        <!--        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1" :href="route('shop.landing-home')" :data="{ anchor: 'categories' }">-->
        <!--          <div class="transition ease-in-out duration-150 ml-1" style="color:#3c3c3c; font-size: 0.8rem !important; border-bottom: 1px solid #3c3c3c"><strong>{{ $t('menu.categoriesAll') }}</strong></div>-->
        <!--        </inertia-link>-->
        <!--      </div>-->
        <!--      <ul slot="body">-->
        <!--        <li v-for="category in categories" :key="category.slug">-->
        <!--          <inertia-link :href="route('shop.category.view', category.slug)">-->
        <!--            <div class="transition ease-in-out duration-150 ml-1" style="color:#3c3c3c; font-size: 0.7rem !important;">-->
        <!--              <span v-if="category.name == 'De 2 X reduse' || category.name == 'Twice discounted'"-->
        <!--                    style="color:red">{{ category.name }}</span>-->
        <!--              <span v-else>{{ category.name }}</span>-->
        <!--            </div>-->
        <!--          </inertia-link>-->
        <!--          <ul v-if="category.mapped">-->
        <!--            <li v-for="mapped in category.mapped" :key="mapped.slug">-->
        <!--              <inertia-link :href="route('shop.category.view', [category.slug, mapped.slug])">-->
        <!--                <span class="ml-6" style="font-size: 0.7rem !important;line-height: 0"><i>- {{ mapped.name }}</i></span>-->
        <!--              </inertia-link>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </li>-->
        <!--      </ul>-->
        <!--      &lt;!&ndash;      <div slot="footer">Dropdown Footer</div>&ndash;&gt;-->
        <!--    </dropdown-menu>-->
        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1" :href="route('shop.landing')"
                      :data="{ anchor: 'highlights' }">
          <div class="transition ease-in-out duration-150" style="color:#3c3c3c; font-size: 1rem !important;">
            {{ $t('menu.highlights') }}
          </div>
        </inertia-link>
        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1" :href="route('shop.howbuy.view')">
          <div class="transition ease-in-out duration-150" style="color:#3c3c3c; font-size: 1rem !important;">
            {{ $t('menu.how_buy') }}
          </div>
        </inertia-link>
        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1" :href="route('shop.howsell.view')">
          <div class="transition ease-in-out duration-150" style="color:#3c3c3c; font-size: 1rem !important;">
            {{ $t('menu.how_sell') }}
          </div>
        </inertia-link>
        <inertia-link class="flex items-center group mr-6 a10-nav-link my-1" :href="route('shop.contact.view')">
          <div class="transition ease-in-out duration-150" style="color:#3c3c3c; font-size: 1rem !important;">
            {{ $t('menu.contact') }}
          </div>
        </inertia-link>
<!--      </div>-->
<!--    </div>-->
<!--    -->
  </div>
</template>
<style>

.v-dropdown-menu__container {
  min-width: 300px !important;
  max-height: 300px !important;
  overflow: auto !important;
}

</style>
<script>
import Icon from '@/Shared/Icon'
import eventBus from "../eventBus";

export default {
  components: {
    Icon,
  },
  props: {
    url: String,
    categories: Object,
  },
  methods: {
    mouseEvent(event, source, key = "") {
      if (source === "item") {
        event.stopPropagation();
      }
      if(key === 'categories'){
        eventBus.$emit('show-mega-menu')
      }
    },
    isUrl(...urls) {
      if (urls[0] === '') {
        return this.url === ''
      }

      return urls.filter(url => this.url.startsWith(url)).length
    },
  },
  mounted() {
    eventBus.$on("hide-mega-menu", () => {
      this.showMegaMenu = true;
    });
  },
  beforeDestroy() {
    eventBus.$off("hide-mega-menu");
  },
}
</script>
